// extracted by mini-css-extract-plugin
module.exports = {"root":"Popup_root__3QT2S","header":"Popup_header__1l_Sm","body":"Popup_body__1Kezw"};